import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import type { IResponseIntegrationDisconnected } from 'entities/Integrations'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventIntegrationDisconnected = () => {
  const { websocket, integrationsStore } = useEntitiesContext()
  const handler = (data: IResponseIntegrationDisconnected) => {
    integrationsStore.syncUserIntegration(data.userIntegration)
  }

  useEffect(() => websocket.on(WebsocketEvent.IntegrationDisconnected, handler), [])
}
